module.exports = __webpack_public_path__ + "img/couples_06_V.728534ed.webp";